// ** Reducers Imports
import navbar from "./navbar";
import layout from "./layout";
import viewer from "./viewer";
import Document from "./documentRedux";
import workspaces from "./workspaces";
import users from "./users";
import tenants from "./tenants";
import license from "./license";
import workspaceFields from "./workspaceFields";
import templateBuilder from "./templateBuilder";
import transcripts from "./transcripts";
import workspacePredefinedTexts from "./workspacePredefinedTexts";
import workspacePredefinedSpeakers from "./workspacePredefinedSpeakers";
import importFiles from "./importFiles";
import notifications from "./notifications";
import taskAssignments from "./taskAssignments";
import home from "./home";
import exporting from "./exporting";
import selectOptions from "./selectOptions";

const rootReducer = {
    navbar,
    layout,
    viewer,
    Document,
    workspaces,
    users,
    tenants,
    workspaceFields,
    templateBuilder,
    transcripts,
    workspacePredefinedTexts,
    workspacePredefinedSpeakers,
    importFiles,
    license,
    notifications,
    taskAssignments,
    home,
    exporting,
    selectOptions,
};

export default rootReducer;
